/**
 * Ryan O'Dowd
 * 2022-04-05
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import LinearGradient from './LinearGradient';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const BackgroundGradient = (_p: BackgroundGradientProps) => {
  const props = {...defaultProps, ..._p};
  const styles = hooks.useStyles(getStyles);

  let colorsToUse = props.colors;
  if (!colorsToUse) {
    if (props.theme === 'white' || props.theme === styles.colors.white) {
      colorsToUse = [
        styles.isDarkMode ? styles.colors.gray : styles.colors.lightGray,
        styles.isDarkMode ? styles.colors.darkText : styles.colors.white,
      ];
    } else if (props.theme === 'dark' || props.theme === styles.colors.dark) {
      colorsToUse = [
        styles.isDarkMode ? styles.colors.completeBg : styles.colors.completeBg,
        styles.isDarkMode ? styles.colors.completeBgDark : styles.colors.completeBgDark,// @TODO: these are the same (and completeBgDark doesn't exist anymore)
      ];
    } else if (props.theme === 'accent' || props.theme === styles.colors.accent) {
      colorsToUse = [
        styles.isDarkMode ? styles.colors.accentDark : styles.colors.accent,
        styles.isDarkMode ? styles.colors.accentExtraDark : styles.colors.accentLight,
      ];
    } else if (props.theme === 'alert' || props.theme === styles.colors.alert) {
      colorsToUse = [
        styles.isDarkMode ? styles.colors.alertDark : styles.colors.alert,
        styles.isDarkMode ? styles.colors.alertExtraDark : styles.colors.alertLight,
      ];
    // @TODO: storm: ['#202f46', '#001d3d'],
    } else {
      // primary
      colorsToUse = [
        styles.isDarkMode ? styles.colors.primaryDark : styles.colors.primary,
        styles.isDarkMode ? styles.colors.primary : styles.colors.primaryLight,
      ];
    }
  }

  if (props.reverse) { // @TODO: could probably get rid of this bool and just pass them in reveresed?
    colorsToUse = [...colorsToUse].reverse(); // need to create a copy so that the original array isn't mutated
  }

  return (
    <LinearGradient
      style={[styles.linearGradient(colorsToUse, props.linearGradientProps, props.opacity, props.darken), ...(Array.isArray(props.style) ? props.style : [props.style])]}
      linearGradientProps={{
        start: {x: props.startX, y: props.startY},
        end: {x: props.endX, y: props.endY},
        colors: colorsToUse,
        opacity: props.opacity,
        ...props.linearGradientProps,
      }}
    />
  );
};

class BackgroundGradientProps {
  colors?: string[];
  style?: any;
  theme?: 'primary' | 'accent' | 'alert' | 'white' | 'dark' = 'primary';
  endX?: number = 0;
  endY?: number = 1;
  opacity?: number = 1.0;
  startX?: number = 0;
  startY?: number = 0;
  linearGradientProps?: any = {};
  reverse?: boolean;
  darken?: boolean;
};
const defaultProps = new BackgroundGradientProps();

BackgroundGradient.displayName = 'BackgroundGradient';
export default BackgroundGradient;
